/* LB 30-10-2026 v35 MUJER (auditoría). Sustituye a lb-packs-21-09.js en la ficha de producto.
   Solo lo que usaba la ficha de mujer de aquel archivo:
   B) «N personas están viendo»: entre 2 y 15, cambia cada 7 s con pasos de 2 o 3 (el tema y lb_pdp_extras escriben 12-34 al azar: aquí mandamos nosotros).
   D) Quita el bloque «Material» bajo el selector (Ayoub 19-09: el material va en la descripción).
   Fuera: el selector de packs (A) y el aviso «ÚLTIMAS UNIDADES DISPONIBLES» (C). */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('lb-product')) return;
  function seeded(str, min, max) {
    var h = 0; for (var i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
    return min + (h % (max - min + 1));
  }
  var VMIN = 2, VMAX = 15;
  var viewers = seeded(location.pathname, 5, 12);
  function fixViewers() {
    var els = document.querySelectorAll('[data-lb-live-viewers]');
    if (!els.length) return;
    var v = String(viewers);
    els.forEach(function (el) { if (el.textContent !== v) el.textContent = v; });
    document.querySelectorAll('.lb-product-live-proof span:last-child').forEach(function (s) {
      var want = viewers === 1 ? ' persona está viendo este producto' : ' personas están viendo este producto';
      var strong = s.querySelector('strong');
      if (strong && strong.nextSibling && strong.nextSibling.nodeType === 3 && strong.nextSibling.nodeValue !== want) strong.nextSibling.nodeValue = want;
    });
  }
  function stepViewers() {
    var step = Math.random() < 0.5 ? 2 : 3;
    var dir = Math.random() < 0.5 ? -1 : 1;
    if (viewers + dir * step > VMAX || viewers + dir * step < VMIN) dir = -dir;
    viewers = Math.min(VMAX, Math.max(VMIN, viewers + dir * step));
    fixViewers();
  }
  function removeMaterial() {
    document.querySelectorAll('body.lb-product .lb-product-material').forEach(function (b) { b.remove(); });
  }
  var ticking = false;
  function all() {
    if (ticking) return; ticking = true;
    try { fixViewers(); removeMaterial(); } finally { ticking = false; }
  }
  function init() {
    all();
    [200, 600, 1200, 2500, 4000].forEach(function (d) { window.setTimeout(all, d); });
    window.setInterval(stepViewers, 7000);
    if (window.MutationObserver) {
      new MutationObserver(function () { window.requestAnimationFrame(all); }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('load', all, { once: true });
})();
